"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = safely_convert_rgba_to_rgb;
var _isHidden = _interopRequireDefault(require("../is-hidden"));
var _makeNoDataRgb = _interopRequireDefault(require("../make-no-data-rgb"));
var _sliceAlpha = _interopRequireDefault(require("../slice-alpha"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function safely_convert_rgba_to_rgb(noDataValue, pixel) {
  return (0, _isHidden.default)(pixel) ? (0, _makeNoDataRgb.default)(noDataValue) : (0, _sliceAlpha.default)(pixel);
}